import { render, staticRenderFns } from "./SheduleList.vue?vue&type=template&id=82debc10&scoped=true"
import script from "./SheduleList.vue?vue&type=script&lang=js"
export * from "./SheduleList.vue?vue&type=script&lang=js"
import style0 from "./SheduleList.vue?vue&type=style&index=0&id=82debc10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82debc10",
  null
  
)

export default component.exports